import { GetterTree } from "vuex";
import { TrialPeriodAdminzoneState } from "@/types/store/adminzone/trialPeriod";
import { RootState } from "@/types/store/adminzone";
import { TrialPeriodData } from "@/types/trial_period";

export const getters: GetterTree<TrialPeriodAdminzoneState, RootState> = {
  GET_TRIAL_PERIOD: (state): Array<TrialPeriodData> => [...state.trialPeriod],
}
